import React from 'react';
import styled, { css } from 'styled-components';
import { AutoConfirm } from './settingOptions/autoConfirm';
import { CapacitySettings } from './settingOptions/capacity';
import { DisplaySettings } from './settingOptions/displaySettings';
import { EmailNotification } from './settingOptions/emailNotification';
import { SMSNotification } from './settingOptions/smsNotification';
import { lighten } from 'polished';

export const OptionsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px;
`;

export const MockContent = styled.div`
    position: fixed;
    top: 0;
    left: 0;
`;

export const CardPreview = styled.div<{ isActive: boolean; }>`
    padding: 16px 10px;
    border: 1px solid #DFDFDF;
    background: #F5F5F5;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${({ isActive }) => {
        if (isActive) {
            return css`
                border: 1px solid #FB2F2F;
                background: #FFF3F3;
            `;
        }
    }}
`;

export const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
`;
export const ContentWrapper = styled.div`
    border-radius: 4px;
`;

export const SpanWrapper = styled.span`
    text-align: left;
`;

export const ModalBody = styled.div<{ gap?: number; padding?: number; }>`
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 16px;
    height: 100%;
    gap: ${({ gap }) => {
        return gap ? `
                ${gap}px
            ` : '0'
    }};
    width:100%;
    @media (max-width: 768px) {
        height: calc(100% - 125px);
    }
`;

export const ToggleAutoConfirm = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    width: 100%;
`;

export const ScheduleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100vh;
    overflow: scroll;
`;

export const Card = styled.div`
    padding: 12px;
    background: #F5F5F5;
    border: 1px dashed #DFDFDF;
    border-radius: 4px;
    width: 100%;
`;

export const CardTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const CardBottom = styled.div`
    display: flex;
    align-items: center;
    gap: 33px;
    margin-top: 8px;
`;

export const IconSettingWrapper = styled.div`
    margin-right: 8px;
`;

export const FlexField = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
`;

export const ColumnFlexField = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 3px;
`;
export const RowFlexField = styled.div<{ gap?: number; }>`
    width: 100%;
    display: flex;
    flex-direction: row;
    ${({ gap }) => {
        if (gap) {
            return css`gap: ${gap}px`
        }
    }
    };
`;

export const ErrorMessage = styled("span")`
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.error};
  background: ${({ theme }) => lighten(0.43, theme.colors.error)};
  padding: 5px 10px;
  border-radius: 3px;
`;

export const CheckBox = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16Z" fill="#4B4F5E" />
    </svg>
);

export const RadioIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#4B4F5E" />
    </svg>
);

export const ActiveRadio = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 17C13.3833 17 14.5627 16.5123 15.538 15.537C16.5133 14.5617 17.0007 13.3827 17 12C17 10.6167 16.5123 9.43733 15.537 8.462C14.5617 7.48667 13.3827 6.99933 12 7C10.6167 7 9.43733 7.48767 8.462 8.463C7.48667 9.43833 6.99933 10.6173 7 12C7 13.3833 7.48767 14.5627 8.463 15.538C9.43833 16.5133 10.6173 17.0007 12 17ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#FB2F2F" />
    </svg>
);

export const DisplayIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#F1F4F7" />
        <mask id="mask0_419_4158" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
            <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_419_4158)">
            <path d="M18 25H27V19H18V25ZM12 28C11.45 28 10.9792 27.8042 10.5875 27.4125C10.1958 27.0208 10 26.55 10 26V14C10 13.45 10.1958 12.9792 10.5875 12.5875C10.9792 12.1958 11.45 12 12 12H28C28.55 12 29.0208 12.1958 29.4125 12.5875C29.8042 12.9792 30 13.45 30 14V26C30 26.55 29.8042 27.0208 29.4125 27.4125C29.0208 27.8042 28.55 28 28 28H12ZM12 26H28V14H12V26Z" fill="#4B4F5E" />
        </g>
    </svg>
);

const AutoConfirmIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#F1F4F7" />
        <mask id="mask0_431_1797" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
            <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_431_1797)">
            <path d="M18.6 24.6L25.65 17.55L24.25 16.15L18.6 21.8L15.75 18.95L14.35 20.35L18.6 24.6ZM20 30C18.6167 30 17.3167 29.7375 16.1 29.2125C14.8833 28.6875 13.825 27.975 12.925 27.075C12.025 26.175 11.3125 25.1167 10.7875 23.9C10.2625 22.6833 10 21.3833 10 20C10 18.6167 10.2625 17.3167 10.7875 16.1C11.3125 14.8833 12.025 13.825 12.925 12.925C13.825 12.025 14.8833 11.3125 16.1 10.7875C17.3167 10.2625 18.6167 10 20 10C21.3833 10 22.6833 10.2625 23.9 10.7875C25.1167 11.3125 26.175 12.025 27.075 12.925C27.975 13.825 28.6875 14.8833 29.2125 16.1C29.7375 17.3167 30 18.6167 30 20C30 21.3833 29.7375 22.6833 29.2125 23.9C28.6875 25.1167 27.975 26.175 27.075 27.075C26.175 27.975 25.1167 28.6875 23.9 29.2125C22.6833 29.7375 21.3833 30 20 30ZM20 28C22.2333 28 24.125 27.225 25.675 25.675C27.225 24.125 28 22.2333 28 20C28 17.7667 27.225 15.875 25.675 14.325C24.125 12.775 22.2333 12 20 12C17.7667 12 15.875 12.775 14.325 14.325C12.775 15.875 12 17.7667 12 20C12 22.2333 12.775 24.125 14.325 25.675C15.875 27.225 17.7667 28 20 28Z" fill="#4B4F5E" />
        </g>
    </svg>
);

const CapacityIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#F1F4F7" />
        <mask id="mask0_431_1972" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
            <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_431_1972)">
            <path d="M8 26V24.425C8 23.7083 8.36667 23.125 9.1 22.675C9.83333 22.225 10.8 22 12 22C12.2167 22 12.425 22.0042 12.625 22.0125C12.825 22.0208 13.0167 22.0417 13.2 22.075C12.9667 22.425 12.7917 22.7917 12.675 23.175C12.5583 23.5583 12.5 23.9583 12.5 24.375V26H8ZM14 26V24.375C14 23.8417 14.1458 23.3542 14.4375 22.9125C14.7292 22.4708 15.1417 22.0833 15.675 21.75C16.2083 21.4167 16.8458 21.1667 17.5875 21C18.3292 20.8333 19.1333 20.75 20 20.75C20.8833 20.75 21.6958 20.8333 22.4375 21C23.1792 21.1667 23.8167 21.4167 24.35 21.75C24.8833 22.0833 25.2917 22.4708 25.575 22.9125C25.8583 23.3542 26 23.8417 26 24.375V26H14ZM27.5 26V24.375C27.5 23.9417 27.4458 23.5333 27.3375 23.15C27.2292 22.7667 27.0667 22.4083 26.85 22.075C27.0333 22.0417 27.2208 22.0208 27.4125 22.0125C27.6042 22.0042 27.8 22 28 22C29.2 22 30.1667 22.2208 30.9 22.6625C31.6333 23.1042 32 23.6917 32 24.425V26H27.5ZM16.125 24H23.9C23.7333 23.6667 23.2708 23.375 22.5125 23.125C21.7542 22.875 20.9167 22.75 20 22.75C19.0833 22.75 18.2458 22.875 17.4875 23.125C16.7292 23.375 16.275 23.6667 16.125 24ZM12 21C11.45 21 10.9792 20.8042 10.5875 20.4125C10.1958 20.0208 10 19.55 10 19C10 18.4333 10.1958 17.9583 10.5875 17.575C10.9792 17.1917 11.45 17 12 17C12.5667 17 13.0417 17.1917 13.425 17.575C13.8083 17.9583 14 18.4333 14 19C14 19.55 13.8083 20.0208 13.425 20.4125C13.0417 20.8042 12.5667 21 12 21ZM28 21C27.45 21 26.9792 20.8042 26.5875 20.4125C26.1958 20.0208 26 19.55 26 19C26 18.4333 26.1958 17.9583 26.5875 17.575C26.9792 17.1917 27.45 17 28 17C28.5667 17 29.0417 17.1917 29.425 17.575C29.8083 17.9583 30 18.4333 30 19C30 19.55 29.8083 20.0208 29.425 20.4125C29.0417 20.8042 28.5667 21 28 21ZM20 20C19.1667 20 18.4583 19.7083 17.875 19.125C17.2917 18.5417 17 17.8333 17 17C17 16.15 17.2917 15.4375 17.875 14.8625C18.4583 14.2875 19.1667 14 20 14C20.85 14 21.5625 14.2875 22.1375 14.8625C22.7125 15.4375 23 16.15 23 17C23 17.8333 22.7125 18.5417 22.1375 19.125C21.5625 19.7083 20.85 20 20 20ZM20 18C20.2833 18 20.5208 17.9042 20.7125 17.7125C20.9042 17.5208 21 17.2833 21 17C21 16.7167 20.9042 16.4792 20.7125 16.2875C20.5208 16.0958 20.2833 16 20 16C19.7167 16 19.4792 16.0958 19.2875 16.2875C19.0958 16.4792 19 16.7167 19 17C19 17.2833 19.0958 17.5208 19.2875 17.7125C19.4792 17.9042 19.7167 18 20 18Z" fill="#4B4F5E" />
        </g>
    </svg>
);

const SMSNotiIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#F1F4F7" />
        <mask id="mask0_431_5690" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
            <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_431_5690)">
            <path d="M20 23C20.2833 23 20.5208 22.9042 20.7125 22.7125C20.9042 22.5208 21 22.2833 21 22C21 21.7167 20.9042 21.4792 20.7125 21.2875C20.5208 21.0958 20.2833 21 20 21C19.7167 21 19.4792 21.0958 19.2875 21.2875C19.0958 21.4792 19 21.7167 19 22C19 22.2833 19.0958 22.5208 19.2875 22.7125C19.4792 22.9042 19.7167 23 20 23ZM19 19H21V13H19V19ZM10 30V12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10H28C28.55 10 29.0208 10.1958 29.4125 10.5875C29.8042 10.9792 30 11.45 30 12V24C30 24.55 29.8042 25.0208 29.4125 25.4125C29.0208 25.8042 28.55 26 28 26H14L10 30ZM13.15 24H28V12H12V25.125L13.15 24Z" fill="#4B4F5E" />
        </g>
    </svg>
);

const EmailNoti = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#F1F4F7" />
        <mask id="mask0_431_4171" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
            <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_431_4171)">
            <path d="M12.1999 27.2004C11.7049 27.2004 11.2812 27.024 10.9287 26.6713C10.5762 26.3186 10.3999 25.8947 10.3999 25.3994V14.5933C10.3999 14.098 10.5762 13.6754 10.9287 13.3254C11.2812 12.9754 11.7049 12.8004 12.1999 12.8004H21.8249C21.7916 13.0837 21.7832 13.3796 21.7999 13.6879C21.8166 13.9962 21.8666 14.3004 21.9499 14.6004H12.1999L19.9999 19.0754L23.4999 17.0504C23.7332 17.2671 24.0416 17.4671 24.4249 17.6504C24.8082 17.8337 25.1499 17.9671 25.4499 18.0504L19.9999 21.2004L12.1999 16.7254V25.4004H27.7999V18.039C28.1332 17.9633 28.4457 17.8462 28.7374 17.6879C29.0291 17.5296 29.3166 17.3504 29.5999 17.1504V25.3947C29.5999 25.8985 29.4207 26.3254 29.0624 26.6754C28.7041 27.0254 28.2832 27.2004 27.7999 27.2004H12.1999ZM26.5999 16.4004C25.7666 16.4004 25.0582 16.1087 24.4749 15.5254C23.8916 14.9421 23.5999 14.2337 23.5999 13.4004C23.5999 12.5671 23.8916 11.8587 24.4749 11.2754C25.0582 10.6921 25.7666 10.4004 26.5999 10.4004C27.4332 10.4004 28.1416 10.6921 28.7249 11.2754C29.3082 11.8587 29.5999 12.5671 29.5999 13.4004C29.5999 14.2337 29.3082 14.9421 28.7249 15.5254C28.1416 16.1087 27.4332 16.4004 26.5999 16.4004Z" fill="#4B4F5E" />
        </g>
    </svg>
);

export const ChrevonRight = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_419_4164" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_419_4164)">
            <path d="M4.79984 14.3996L3.6665 13.2663L8.93317 7.99961L3.6665 2.73294L4.79984 1.59961L11.1998 7.99961L4.79984 14.3996Z" fill="#4B4F5E" />
        </g>
    </svg>
);
type OPTION_LIST_TYPE = {
    handleClose: () => void;
}
export const getOptionList = ({ handleClose }: OPTION_LIST_TYPE) => [
    {
        id: 'display-settings',
        label: 'Display Settings',
        icon: <DisplayIcon />,
        content: <DisplaySettings handleClose={handleClose} />
    },
    {
        id: 'auto-confirm',
        label: 'Auto Confirm',
        icon: <AutoConfirmIcon />,
        content: <AutoConfirm handleClose={handleClose} />
    },
    // {
    //     id: 'capacity',
    //     label: 'Capacity',
    //     icon: <CapacityIcon />,
    //     content: <CapacitySettings handleClose={handleClose} />
    // },
    {
        id: 'sms-notification',
        label: 'SMS Notification',
        icon: <SMSNotiIcon />,
        content: <SMSNotification handleClose={handleClose} />
    },
    {
        id: 'email-notification',
        label: 'Email Notification',
        icon: <EmailNoti />,
        content: <EmailNotification handleClose={handleClose} />
    },
];